import branchDlgMul from './branchDlgMul.js'

const wasteMan = {
  namespaced: true,
  modules: {
    branchDlgMul
  }
}

export default wasteMan
